import { render } from "./LegacyDetailedAlarmReportSettings.vue?vue&type=template&id=b1e5949c"
import script from "./LegacyDetailedAlarmReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyDetailedAlarmReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__